import { Grid } from 'components/Grid';
import { useAuthContext } from 'context/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { MainImage } from './components/MainImage';
import { Heading } from 'components/CommonComponents';
import { PrimaryButton } from 'components/Buttons';
import { PAD_MEDIUM_NUMBER } from 'providers/designSystem';
import { CenteredContent } from 'components/CenteredContent';
import { Box } from '@mui/material';

export const Homepage = () => {
    const [isAuthenticated] = useAuthContext();
    const navigate = useNavigate();

    const handleClick = () => {
        const nextPage = isAuthenticated ? '/colour-palettes' : '/login';
        navigate(nextPage);
    };

    return (
        <Box
            sx={{
                position: 'relative',
                top: '-36px',
            }}
        >
            <CenteredContent height="80vh">
                <Grid numberOfColumns={1} justifyItems="center" gap={PAD_MEDIUM_NUMBER}>
                    <MainImage />
                    <Heading>Colour Palette Builder</Heading>
                    <PrimaryButton onClick={handleClick}>Get Started</PrimaryButton>
                </Grid>
            </CenteredContent>
        </Box>
    );
};
